<p class="float-end m-0 custom-text">
  {{ 'user_cannot_write_alert' | translation }}
</p>
